import { FeatureToggles } from "@paralleldrive/react-feature-toggles";
import { Outlet } from "react-router";
import styled from "styled-components";
import { GlobalStyle } from "legacy/global-styles";
import DocumentLanguageUpdater from "legacy/containers/App/addons/DocumentLanguageUpdater";
import ScrollToTop from "legacy/containers/App/addons/ScrollToTop";
import { useFeatureToggles } from "legacy/containers/App/hooks/useFeatureToggles";
import { AuthRedirectListener } from "./auth/auth-redirect-listener";

const AppWrapper = styled.div`
  width: 100%;
  min-height: 100vh;
`;

export const ApplicationShell = () => {
  const features = useFeatureToggles();

  return (
    <>
      <AuthRedirectListener />
      <DocumentLanguageUpdater>
        <FeatureToggles features={features}>
          <AppWrapper>
            <Outlet />
            <ScrollToTop />
            <GlobalStyle />
          </AppWrapper>
        </FeatureToggles>
      </DocumentLanguageUpdater>
    </>
  );
};
